import {state} from '@/store/modules/Conversations/state';
import {getters} from '@/store/modules/Conversations/getters';
import {actions} from '@/store/modules/Conversations/actions';
import {mutations} from '@/store/modules/Conversations/mutations';

export default {
    state,
    getters,
    actions,
    mutations,
};
